"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconQuarterHour = function IconQuarterHour(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M23.999 4c11.046 0 20 8.954 20 20s-8.954 20-20 20-20-8.954-20-20 8.954-20 20-20M23 6.027a17.9 17.9 0 0 0-7.882 2.313l1.174 2.033a.5.5 0 0 1-.866.5l-1.164-2.015c-2.2 1.418-4.07 3.301-5.473 5.511l2.179 1.258a.5.5 0 0 1-.5.866l-2.19-1.264a17.9 17.9 0 0 0-2.271 8.267H8.5a.5.5 0 0 1 .001 1H6.006a17.9 17.9 0 0 0 1.867 7.507l2.273-1.242a.5.5 0 0 1 .48.877l-2.284 1.248a18.1 18.1 0 0 0 5.817 6.187l1.267-2.193a.5.5 0 0 1 .866.5l-1.281 2.219a17.9 17.9 0 0 0 8.502 2.394V39.5a.501.501 0 0 1 1 0v2.492a17.9 17.9 0 0 0 8.235-2.26l-1.265-2.192a.5.5 0 1 1 .866-.5l1.26 2.182a18.1 18.1 0 0 0 6.06-6.363l-2.235-1.221a.5.5 0 1 1 .48-.877l2.224 1.216A17.9 17.9 0 0 0 41.972 25H26.309a2.498 2.498 0 0 1-4.766-1.052c0-1.008.598-1.875 1.457-2.27zm1.043 16.421a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m.957-.81A2.5 2.5 0 0 1 26.355 23H41.97C41.469 13.855 34.144 6.529 25 6.027zm10.94-6.708H33.3l-.16 1.31c.32-.34.721-.51 1.261-.51 1.08 0 2.05.73 2.05 2.12 0 1.44-1.11 2.27-2.55 2.27-1.13 0-2.05-.47-2.59-.91l.75-1.32c.51.45 1.19.79 1.83.79.61 0 .97-.31.97-.83 0-.54-.38-.84-.91-.84-.39 0-.69.16-.95.44l-1.28-.43.41-3.52h3.81zM30.43 20h-1.54v-4.2c-.33.18-.72.28-1.11.28h-.53v-1.45h.53c.66 0 1.24-.44 1.24-1.08v-.05h1.41z"
  })));
};

export { IconQuarterHour, IconQuarterHour as default };
